module.exports = __webpack_public_path__ + "media/assets/img/flags/en-GB-1dcb58cb667c8dee4b375001d96f29e9.png";